const contentStyle = {
  contentContainer: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
};

export default contentStyle;